<template>
    <form v-on:submit.prevent="handleSearch">
    <div class="search-wrapper">
        <div class="search-wrapper-left">
            <Row :gutter="16" class-name="row-margin-bottom">
                <Col span="4">
                    <Input v-model="searchData.keyword" clearable placeholder="姓名/手机号/用户编号" ></Input>
                </Col>
                <Col span="4">
                    <Select v-model="searchData.companyGroupId" clearable  placeholder="所属部门">
                        <Option v-for="item in groupList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    <Button  @click="handleSearch" class="search-button" type="primary">搜索</Button>
                </Col>
            </Row>
        </div>

<!--        <div class="search-wrapper-right">-->
<!--            <Row class-name="row-margin-bottom">-->
<!--                <Col span="24" style="text-align:center">-->
<!--                    <Button  @click="handleSearch" class="search-button" type="primary">搜索</Button>-->
<!--                </Col>-->
<!--            </Row>-->
<!--        </div>-->
    </div>
    </form>
</template>

<script>
    import $api from "@/service/index"
    export default {
        data() {
            return {
                searchData:{
                    keyword: "",
                    companyGroupId:"0",
                },
                groupList : [],
            };
        },
        created(){
            this.getGroupList();
        },
        methods:{
            //搜索按钮点击事件
            handleSearch(){
                this.$emit('selectSearch',this.searchData);
            },
            //获取所有部门备选项
            getGroupList(){
                let _self = this;
                $api.getCompanyUserGroup("group").then(data=>{
                    _self.groupList = data;
                });
            },
            //手动设置搜索项
            setSearchData(searchData){
                if(searchData){
                    this.searchData = Object.assign({},searchData);
                }
            }
        }
    };
</script>

<style scoped>
    @import "./listSearch.less";
</style>



// WEBPACK FOOTER //
// src/pages/company/member/business/ListSearch.vue